var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewController } from "ionic-angular";
import { SlideCmp } from "./slide-component";
var Slide = (function (_super) {
    __extends(Slide, _super);
    function Slide(app, component, data, opts) {
        if (data === void 0) { data = {}; }
        if (opts === void 0) { opts = {}; }
        var _this = this;
        data.component = component;
        data.opts = opts;
        _this = _super.call(this, SlideCmp, data, null) || this;
        _this.isOverlay = true;
        _this._app = app;
        return _this;
    }
    Slide.prototype.getTransitionName = function (direction) {
        return 'slide-' + (direction === 'back' ? 'out' : 'in');
    };
    Slide.prototype.present = function (navOptions) {
        return this._app.present(this, navOptions);
    };
    return Slide;
}(ViewController));
export { Slide };
//# sourceMappingURL=slide.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-image-slide/dist/components/slide.js
// module id = 722
// module chunks = 20